import React, { useState, useContext } from 'react'
import ReactDOM from 'react-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ModalWindow from '../../../layout/modalwindow/ModalWindow'
import ProductsInventoryOptionsForm from './forms/ProductsInventoryOptionsForm'
import InventoryStyle from './css/InventoryStyle'
import ProductsSoldController from './reports/productssold/ProductsSoldController'
import UnmovingProductsController from './reports/unmovingproducts/UnmovingProductsController'
import { appContext } from '../../../../App'

function Inventory() {
  const app = useContext(appContext)
  const setContent = app.content[1]
  const [showHeader, setShowHeader] = useState(true)
  const windowOptionsDimension = { width: '40', height: '60' }

  const onClickProductsInventory = (e) => {
    ReactDOM.render(
      <ModalWindow
        id='mw-parent'
        width={windowOptionsDimension.width}
        height={windowOptionsDimension.height}
        header={'Set Options (Inventory)'}
        footer={null}>
        <ProductsInventoryOptionsForm app={app} rep='inventory' />
      </ModalWindow>,
      document.getElementById('modal-form-container')
    )
  }

  const onClickOutOfStockItems = (e) => {
    ReactDOM.render(
      <ModalWindow
        id='mw-parent'
        width={windowOptionsDimension.width}
        height={windowOptionsDimension.height}
        header={'Set Options (Out of Stock)'}
        footer={null}>
        <ProductsInventoryOptionsForm app={app} rep='out_of_stock' />
      </ModalWindow>,
      document.getElementById('modal-form-container')
    )
  }

  const onClickProductsPriceList = (e) => {
    ReactDOM.render (
      <ModalWindow
        id='mw-parent'
        width={windowOptionsDimension.width}
        height={windowOptionsDimension.height}
        header={'Set Options (Products Price List)'}
        footer={null}>
        <ProductsInventoryOptionsForm app={app} rep='price_list'/>
      </ModalWindow>,
      document.getElementById('modal-form-container')
    )
  }

  const onClickProductsWithExpirations = (e) => {
    ReactDOM.render(
      <ModalWindow
        id='mw-parent'
        width={windowOptionsDimension.width}
        height={windowOptionsDimension.height}
        header={'Set Options (Products With Expirations Inventory)'}
        footer={null}>
        <ProductsInventoryOptionsForm app={app} rep='products_with_expirations'/>
      </ModalWindow>,
      document.getElementById('modal-form-container')
    )
  }

  const onClickProductsSold = (e) => { setContent(<ProductsSoldController />) }
  const onClickUnmovingProducts = (e) => { setContent(<UnmovingProductsController />) }
  const onClickHeader = (e) => { setShowHeader(!showHeader) }

  return (
    <React.Fragment>
      <div className='report-item-container'>
        <button id='inventory' onClick={onClickHeader} className='report-item-header'>
          Inventory &nbsp;<span style={{marginTop: '2px'}}><FontAwesomeIcon icon={(showHeader) ? 'caret-down' : 'caret-right'}/></span>
        </button>
        <div className={(showHeader) ? 'report-items-container' : 'hide-ric'}>
          <button
            id='products-inventory-btn'
            onClick={onClickProductsInventory}
            className='report-item-wrapper'>
            <div className='report-item-title'>Products Inventory</div>
            <div className='report-item-description'>
            Inventory report of all items.
            </div>
          </button>
          <button
            id='out-of-stocks-btn'
            onClick={onClickOutOfStockItems}
            className='report-item-wrapper'>
            <div className='report-item-title'>Out Of Stocks</div>
            <div className='report-item-description'>
            Item's below/equal to inventory critical level.
            </div>
          </button>
          <button
            id='price-list-btn'
            onClick={onClickProductsPriceList}
            className='report-item-wrapper'>
            <div className='report-item-title'>Price List</div>
            <div className='report-item-description'>
            List of items prices (FOB, whole sale, etc..).
            </div>
          </button>
          <button
            id='products-sold-btn'
            onClick={onClickProductsSold}
            className='report-item-wrapper'>
            <div className='report-item-title'>Products Sold</div>
            <div className='report-item-description'>
            List frequency of items sold.
            </div>
          </button>
          <button
            id='unmoving-products-btn'
            onClick={onClickUnmovingProducts}
            className='report-item-wrapper'>
            <div className='report-item-title'>Unmoving Products</div>
            <div className='report-item-description'>
            Products not sold for a period of time.
            </div>
          </button>
          <button
            id='products-with-expirations-btn'
            onClick={onClickProductsWithExpirations}
            className='report-item-wrapper'>
            <div className='report-item-title'>Products With Expirations</div>
            <div className='report-item-description'>
            List of products with expiration dates.
            </div>
          </button>
        </div>
      </div>
      <InventoryStyle signed_in={app.client.signed_in}/>
    </React.Fragment>
  )
}

export default React.memo(Inventory)